let baseUrl = process.env.REACT_APP_GFS_BASE_URL

export default async function HistoricData(lat, lng, days = 7) {
    let url = `${baseUrl}/interpolate/historical?lat=${lat}&lon=${lng}&days=${days}`;
    let result = await fetch(url);

    if (!result.ok) {
        throw new Error(`HTTP error! status: ${result.status}`);
    }

    return await result.json();

}
